/**
 * Dashboard Service
 * API integration for dashboard data aggregation
 *
 * @version 2025.2.0
 */
import apiClient from './apiClient';
import { DashboardData, DashboardApiResponse } from '../types/dashboard';
import { motivoDaRecusa } from '../utils/acessoNegado';

// Re-export types for convenience
export * from '../types/dashboard';

class DashboardService {
  private baseUrl = '/dashboard';

  /**
   * Get dashboard data (aggregated stats, appointments, and alerts)
   */
  async getDashboard(): Promise<DashboardData> {
    try {
      const response = await apiClient.get<DashboardApiResponse>(this.baseUrl);
      const responseData = response.data;
      const data = responseData?.data || responseData;
      return data as DashboardData;
    } catch (error) {
      console.error('[DashboardService] Error fetching dashboard:', error);
      // A recusa de acesso sobe: engoli-la devolvia um painel vazio idêntico ao de quem não
      // tem número nenhum para mostrar, e é assim que "seu perfil não inclui o painel" virava
      // uma tela em branco sem explicação. Falha de rede continua caindo no painel vazio.
      if (motivoDaRecusa(error)) throw error;
      return { blocos: [] };
    }
  }
}

// Export singleton instance
export const dashboardService = new DashboardService();
export default dashboardService;
